import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetMissingRefBadgeCountQueryVariables = Types.Exact<{
  customerId: Types.Scalars['bigint']['input'];
  withStops: Types.Scalars['Boolean']['input'];
}>;


export type GetMissingRefBadgeCountQuery = { __typename?: 'query_root', completedMovesMissingRef: { __typename?: 'moves_aggregate', aggregate?: { __typename?: 'moves_aggregate_fields', count: number } | null }, completedStopsMissingRo?: { __typename?: 'mobility_stops_aggregate', aggregate?: { __typename?: 'mobility_stops_aggregate_fields', count: number } | null } };


export const GetMissingRefBadgeCountDocument = gql`
    query getMissingRefBadgeCount($customerId: bigint!, $withStops: Boolean!) {
  completedMovesMissingRef: moves_aggregate(
    where: {active: {_eq: 1}, move_type: {_eq: "drive"}, consumer_pickup: {_eq: true}, reference_num: {_is_null: true}, cancel_status: {_is_null: true}, status: {_eq: "delivery successful"}, _or: [{customer_id: {_eq: $customerId}}, {payer_id: {_eq: $customerId}}]}
  ) {
    aggregate {
      count
    }
  }
  completedStopsMissingRo: mobility_stops_aggregate(
    where: {product_type: {_eq: "mobile_service"}, status: {_eq: "completed"}, run: {customer_id: {_eq: $customerId}, status: {_neq: "cancelled"}}, service_orders: {}, _and: [{_not: {service_orders: {appointment: {ro_number: {_is_null: false}}}}}, {_not: {service_stop_detail: {ro_reference: {_is_null: false}}}}]}
  ) @include(if: $withStops) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetMissingRefBadgeCountQuery__
 *
 * To run a query within a React component, call `useGetMissingRefBadgeCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMissingRefBadgeCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMissingRefBadgeCountQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      withStops: // value for 'withStops'
 *   },
 * });
 */
export function useGetMissingRefBadgeCountQuery(baseOptions: Apollo.QueryHookOptions<GetMissingRefBadgeCountQuery, GetMissingRefBadgeCountQueryVariables> & ({ variables: GetMissingRefBadgeCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMissingRefBadgeCountQuery, GetMissingRefBadgeCountQueryVariables>(GetMissingRefBadgeCountDocument, options);
      }
export function useGetMissingRefBadgeCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMissingRefBadgeCountQuery, GetMissingRefBadgeCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMissingRefBadgeCountQuery, GetMissingRefBadgeCountQueryVariables>(GetMissingRefBadgeCountDocument, options);
        }
// @ts-ignore
export function useGetMissingRefBadgeCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMissingRefBadgeCountQuery, GetMissingRefBadgeCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetMissingRefBadgeCountQuery, GetMissingRefBadgeCountQueryVariables>;
export function useGetMissingRefBadgeCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMissingRefBadgeCountQuery, GetMissingRefBadgeCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetMissingRefBadgeCountQuery | undefined, GetMissingRefBadgeCountQueryVariables>;
export function useGetMissingRefBadgeCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMissingRefBadgeCountQuery, GetMissingRefBadgeCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMissingRefBadgeCountQuery, GetMissingRefBadgeCountQueryVariables>(GetMissingRefBadgeCountDocument, options);
        }
export type GetMissingRefBadgeCountQueryHookResult = ReturnType<typeof useGetMissingRefBadgeCountQuery>;
export type GetMissingRefBadgeCountLazyQueryHookResult = ReturnType<typeof useGetMissingRefBadgeCountLazyQuery>;
export type GetMissingRefBadgeCountSuspenseQueryHookResult = ReturnType<typeof useGetMissingRefBadgeCountSuspenseQuery>;
export type GetMissingRefBadgeCountQueryResult = Apollo.QueryResult<GetMissingRefBadgeCountQuery, GetMissingRefBadgeCountQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * Multiple root fields (completedMovesMissingRef, completedStopsMissingRo): returns the full response object.
 * @source {@link src/features/missingRefReport/queries/getMissingRefBadgeCount.query.gql}
 */
export async function getMissingRefBadgeCount(
  variables: GetMissingRefBadgeCountQueryVariables,
  options?: { executor?: GqlExecutor } & GqlRequestOptions
): Promise<GetMissingRefBadgeCountQuery> {
  const { executor, ...requestOptions } = options ?? {}
  return resolveExecutor(executor).query<GetMissingRefBadgeCountQuery>(
    GetMissingRefBadgeCountDocument,
    variables,
    requestOptions
  )
}